import ScrollMagic from "scrollmagic";

const parallaxAnimation = () =>
{
    let w = window.innerWidth;

    const parallaxAnimationInit = () => {

            // Gestione Scene con Parallasse
            var allScene = document.querySelectorAll(".scene-parallax");
            if (allScene.length)
            {
                var controllerParallax = new ScrollMagic.Controller();
                allScene.forEach(function(item){
                    var elementsToAnimate = item.querySelectorAll(".parallax-effect");
                    if (!elementsToAnimate.length) return;
                    var sceneParallax = new ScrollMagic.Scene (
                    {
                        triggerHook: 'onEnter',
                        triggerElement: item,
                        duration: window.innerHeight*1.5,
                    })
                    .on('progress', function(evt)
                    {
                        elementsToAnimate.forEach(function(element)
                        {
                            var dataShift = element.getAttribute('data-shift');
                            // var dataShift = 200;
    
                            var halfShift = dataShift * 0.05;

                            if( w > 1023 ) {   
                                element.style.transform = 'translateY(' + (halfShift - (dataShift * evt.progress)) + 'px)';
                            }
                            else
                            {
                                element.style.transform = 'translateY(0px)';
                            }
                        });
                    })
                    .addTo(controllerParallax);
    
                });
            }
    }

    const pageResize = () => {
        w = window.innerWidth;
        if(w > 1023) {
            parallaxAnimationInit();
        }
    }

    parallaxAnimationInit();

    window.onresize = pageResize;
}

export
{
    parallaxAnimation
}